export const saveToLocalStorage = (key: string, value: any) => {
    localStorage.setItem(key, JSON.stringify(value));
};

export const getFromLocalStorage = (key: string) => {
    const value = localStorage.getItem(key);
    try {
        const  parsedValue = value && JSON.parse(value);
        return parsedValue ? parsedValue : null;
    } catch(error) {
        return null;
    }
};

export const removeFromLocalStorageByKey = (key: string) => {
    localStorage.removeItem(key);
};